import { Component, OnInit, Input } from '@angular/core';
import { AppState, AppMessageEvent, AppErrorMessageEvent, AppSuccessMessageEvent, AppInfoMessageEvent } from '../core'
import { timer } from 'rxjs';
import { trigger, style, animate, transition } from '@angular/animations';

@Component({
  selector: 'app-notification-panel',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss'],
  animations: [
    trigger('fade', [
      transition(':enter', [ style({opacity: 0}), animate(200, style({opacity: 1})) ]),
      transition(':leave', animate(600, style({opacity: 0})))
    ])/*,
    trigger('slide', [
      transition(':enter', [
        style({transform: 'translateX(100%)'}),
        animate('200ms ease-in', style({transform: 'translateX(0%)'}))
      ]),
      transition(':leave', [
        animate('200ms ease-in', style({transform: 'translateX(100%)'}))
      ])
    ])*/
  ]
})
export class NotificationComponent implements OnInit {
  
  events : AppMessageEvent[] = []

  static readonly MAX_CNT = 5

  constructor(public appState: AppState) { 
    appState.notifyErrorEmitter.subscribe(this.displayEvent)
    appState.notifyWarningEmitter.subscribe(this.displayEvent)
    appState.notifySuccessEmitter.subscribe(this.displayEvent)
    appState.notifyInfoEmitter.subscribe(this.displayEvent)
  }

  ngOnInit(): void { 
  }


  displayEvent = ( event : AppMessageEvent) => {
    if ( event?.message ) {
      // allow only one notification bubble per source
      this.events = this.events.filter( evt => evt.source != event.source )
      this.events.push(event)
      timer( event.expireSeconds*1000 ).subscribe( ms => {
        this.remove( event )
      })
    }
    if ( this.events.length > NotificationComponent.MAX_CNT ) {
      this.events.shift()
    }
  }

  public remove = ( event : AppMessageEvent) => {
    this.events = this.events.filter( evt => evt != event)
  }
}
